<template>
  <div style="height: auto; min-height: 100%; background-color: #231232">
    <div class="background">
      <img style="position: absolute; top: 0; width: 100%" src="@/assets/deco/home-main-top.png" />
      <video autoplay muted loop class="video" preload="auto" playsinline="true">
        <source src="@/assets/bgmovie.mp4" type="video/mp4" />
      </video>
      <!-- <img style="position: absolute; bottom: 0; left: 0; width: 100%" src="@/assets/deco/home-main-bottom.png" /> -->
    </div>

    <!-- -->
    <v-sheet class="content d-flex flex-column justify-center align-center" style="top: 10%">
      <v-img src="@/assets/logo/home-main.png" width="50%" />
      <div class="text-body-1 text-md-h6 font-weight-regular font-weight-md-light white--text text-center my-4">
        다 똑같은 사진관이 지루했던 우리는 <br />
        [무인사진관]에 [테마파크]를 <br />
        담아보기로 했어요<br /><br />
        최초의 '테마파크 무인 스튜디오'
      </div>

      <v-img width="180" aspect-ratio="2" src="@/assets/logo/sela-main-title.png" contain />

      <v-img width="180" height="32" contain class="mx-auto" src="@/assets/deco/line_0.png" style="transform: rotate(180deg); margin-top: -20px"></v-img>
      <!-- 이용 시간 -->
      <span class="mt-4 mt-md-6 white--text text-center text-caption font-weight-light" color="white">
        OPEN : PM 12:00 / LAST ENTRY : PM 8:00 <br />
        HOLIDAY : 월 (MON)
      </span>
    </v-sheet>
    <div class="bottom">
      <!-- 약관 버튼 -->
      <div class="d-flex justify-center mt-1">
        <v-btn text small to="/policy/rule?type=read" style="color: rgb(141, 141, 141)"> {{ $t("bottom.use_terms") }} </v-btn>
        <span style="color: rgb(141, 141, 141)">&nbsp;/&nbsp;</span>
        <v-btn class="font-weight-bold" text small to="/policy/privacy?type=read" style="color: rgb(141, 141, 141)"> {{ $t("bottom.private_terms") }}</v-btn>
      </div>
      <!-- 하단 Footer -->
      <Bottom />
    </div>
    <InappBrowserWarningDialog @input="(e) => (show_warning_dialog = e)" @confirm="show_warning_dialog = false" :visible="!qrlogin_compl_dialog && show_warning_dialog" />
    <QrloginComplDialog @input="(e) => (qrlogin_compl_dialog = e)" @close="qrlogin_compl_dialog = false" :visible="qrlogin_compl_dialog" />
  </div>
</template>
<script>
import Bottom from "./components/Bottom.vue"
import InappBrowserWarningDialog from "@/views/components/InappBrowserWarningDialog"
import QrloginComplDialog from "@/views/components/QrcodeLoginCompleteDialog"
import { mapState, mapGetters, mapMutations } from "vuex"

export default {
  components: {
    Bottom,
    InappBrowserWarningDialog,
    QrloginComplDialog,
  },

  created() {
    //const inAppBrowers = ["KAKAO", "FB", "Instragram", "trill", "NAVER"]
    //const isInAppConfig = inAppBrowers.some((e) => navigator.userAgent.indexOf(e) >= 0)
    // confirm(navigator.userAgent)
    // if (isInAppConfig) {
    //   alert("인앱 브라우저에서는 로그인등 정상적인 진행이 어려울 수 있습니다.")
    //   return
    // }
  },

  data: () => ({
    show_warning_dialog: false,
    qrlogin_compl_dialog: false,
    list: [],
  }),

  mounted() {
    // 목록 불러오기
    // this.load()
    if (this.$route.query.qrlogin === "true") {
      this.qrlogin_compl_dialog = true
    } else if (!this.$store.state.lafia_user.is_logined) {
      // 비로그인 사용자만
      console.log("isShowinappBrowserWarning", this.$store.state.isShowinappBrowserWarning)
      this.show_warning_dialog = !this.$store.state.isShowinappBrowserWarning
      if (this.show_warning_dialog) {
        this.$store.commit("SET_INAPPBROWER_STATE", true)
      }
    }

    let lang = this.$route.query.lang
    if (lang && ["ko", "en", "jp"].includes(lang)) {
      this.SET_LANG(lang)
    }
  },

  methods: {
    ...mapMutations(["SET_LANG"]),
    // 목록 불러오기
    load() {
      this.$http.post("/api/concept/select").then((res) => {
        console.log(res)
        if (res.data.length) {
          this.list = res.data
        }
      })
    },
  },
}
</script>
<style scoped>
.background {
  margin-top: -68px;
  width: 100%;
  height: auto;
  overflow: hidden;
  pointer-events: none;
}

.video {
  width: 100%;
}

.content {
  position: absolute;
  width: 100%;
  height: auto;
  top: 0;
  background-color: transparent;
}

.bottom {
  background-color: #231232;
  border-top: 1px solid #c2bcba;
}

.container {
  width: 100%;
  overflow: hidden;
}

.main_title {
  color: rgb(187, 141, 119);
  font-size: 34px;
}

.slide-left-container {
  display: flex;
  justify-content: center;
  align-items: center;
  align-items: center;
  animation: loop-left 800s linear infinite;
}

.slide-left-container > div {
  transition: transform 0.5s ease;
  transform: scale(1);
  object-fit: cover;
  cursor: pointer;
}

@keyframes loop-left {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-100%);
  }
}
@-webkit-keyframes loop-left {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-100%);
  }
}

@keyframes loop-right {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
}

@-webkit-keyframes loop-right {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
}
</style>
